/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import PhotoshopHostInternal from './hosts/photoshop/PhotoshopHostInternal';
import PhotoshopHostExternal from './hosts/photoshop/PhotoshopHostExternal';
import IllustratorHostInternal from './hosts/illustrator/IllustratorHostInternal';
import IllustratorHostExternal from './hosts/illustrator/IllustratorHostExternal';
import IsomorphicMessageBridge from './isomorphicMessageBridge';

const IS_INTERNAL = !!window.uxpHost;
const { send, subscribe } = IsomorphicMessageBridge;
const externalHosts = [PhotoshopHostExternal, IllustratorHostExternal];
const internalHosts = [PhotoshopHostInternal, IllustratorHostInternal];
const createHost = (hostAppName, element, attachHost = true) => {
  let Host;
  let hostObj;

  if (window.uxpHost) {
    Host = internalHosts.find(currentHost => currentHost.check(hostAppName));
    hostObj = new Host({}, document.querySelector('#app'));
  } else {
    Host = externalHosts.find(currentHost => currentHost.check(hostAppName));
    if (attachHost) {
      hostObj = new Host(element || document.querySelector('#app'));
    }
  }

  if (attachHost) {
    window.ccxComments = hostObj;
  }

  return Host;
};

const setupHost = (newAppId, element, attachHost) => {
  let Host;

  if (IS_INTERNAL) {
    send('getAppName').then(appNameResp => createHost(appNameResp));
  } else {
    subscribe('getAppName', msgGuid => send('setAppName', newAppId, msgGuid, false));
    Host = createHost(newAppId, element, attachHost);
  }
  return Host;
};

export default setupHost;
